/**
 * New typescript file
 */

import {Component, EventEmitter, Input, Output} from '@angular/core';
import {animate, style, transition, trigger} from "@angular/animations";

declare var jQuery: any;

@Component({
    selector: 'efast-errormessage',
    templateUrl: 'efast-errormessage.component.html',
    animations: [
        trigger('slideInOut', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate('250ms ease-in', style({ transform: 'translateY(0%)' }))
            ]),
            transition(':leave', [
                animate('250ms ease-in', style({ transform: 'translateY(-100%)' }))
            ])
        ])
    ],
    standalone: false
})

export class EfastErrormessageComponent {

    @Input() efastFieldId: string;
    @Input() efastErrorMsg: string;
    @Input() efastErrorState: boolean = false;

    constructor() {

    }
  
    ngOnInit() {

	}
    
    ngAfterViewInit() {

    }
    onInputHandler(event): void {

        this.outputEfastModel();
    }
    ngOnDestroy() {

    }
    outputEfastModel() {
        //this.efastModelChange.emit(this.efastModel);
    }
}
